//import store from "../index";

const AUTHTOKEN_LOGOUT = "AUTHTOKEN_LOGOUT";
const EQUIPMENT_REQUEST = "EQUIPMENT_REQUEST";
const EQUIPMENT_ERROR = "EQUIPMENT_ERROR";
const EQUIPMENT_SUCCESS = "EQUIPMENT_SUCCESS";
const EQUIPMENTDETAIL_REQUEST = "EQUIPMENTDETAIL_REQUEST";
const EQUIPMENTALARMS_REQUEST = "EQUIPMENTALARMS_REQUEST";
const EQUIPMENTRESYNC_REQUEST = "EQUIPMENTRESYNC_REQUEST";
const SPARES_INVENTORY_REQUEST = "SPARES_INVENTORY_REQUEST";
const SPARES_INVENTORY_SUCCESS = "SPARES_INVENTORY_SUCCESS";
const SPARES_INVENTORY_CREATE_ENTRY = "SPARES_INVENTORY_CREATE_ENTRY";
const SPARES_INVENTORY_UPDATE_SUCCESS = "SPARES_INVENTORY_UPDATE_SUCCESS";
const SPARES_INVENTORY_UPDATE = "SPARES_INVENTORY_UPDATE";
const SPARES_INVENTORY_DELETE_ENTRY = "SPARES_INVENTORY_DELETE_ENTRY";
const SPARES_INVENTORY_UPDATE_ENTRY = "SPARES_INVENTORY_UPDATE_ENTRY";

const PORT_LIGHT_REQUEST = "PORT_LIGHT_REQUEST";
const PORT_TRAFFIC_REQUEST = "PORT_TRAFFIC_REQUEST";
const PORT_LIGHTHISTORY_REQUEST = "PORT_LIGHTHISTORY_REQUEST";
const PORT_TRAFFICHISTORY_REQUEST = "PORT_TRAFFICHISTORY_REQUEST";
const PORT_LINKSTATUS_REQUEST = "PORT_LINKSTATUS_REQUEST";
const PORT_DETAILS_REQUEST = "PORT_DETAILS_REQUEST";
const SITE_EQUIPMENT_REQUEST = "SITE_EQUIPMENT_REQUEST";
const SITE_EQUIPMENT_SUCCESS = "SITE_EQUIPMENT_SUCCESS";
const SITE_EQUIPMENT_ERROR = "SITE_EQUIPMENT_ERROR";
const EQUIPMENT_CREATE = "EQUIPMENT_CREATE";
const EQUIPMENT_CREATE_SUCCESS = "EQUIPMENT_CREATE_SUCCESS";
const EQUIPMENT_CREATE_ERROR = "EQUIPMENT_CREATE_ERROR";
const EQUIPMENT_UPDATE = "EQUIPMENT_UPDATE";
const EQUIPMENT_UPDATE_SUCCESS = "EQUIPMENT_UPDATE_SUCCESS";
const EQUIPMENT_UPDATE_ERROR = "EQUIPMENT_UPDATE_ERROR";
const EQUIPMENT_DELETE = "EQUIPMENT_DELETE";
const EQUIPMENT_DELETE_SUCCESS = "EQUIPMENT_DELETE_SUCCESS";
const EQUIPMENT_DELETE_ERROR = "EQUIPMENT_DELETE_ERROR";
const EQUIPMENT_SITEINVENTORY_REQUEST = "EQUIPMENT_SITEINVENTORY_REQUEST"
const EQUIPMENT_SITEINVENTORY_SUCCESS = "EQUIPMENT_SITEINVENTORY_SUCCESS"
const EQUIPMENT_SITEINVENTORY_ERROR = "EQUIPMENT_SITEINVENTORY_ERROR"

//AWX Jobs
const EQUIPMENT_LOG_REQUEST = "EQUIPMENT_LOG_REQUEST";
const EQUIPMENTRSI_REQUEST = "EQUIPMENTRSI_REQUEST";
const EQUIPMENT_VAR_LOG_REQUEST = "EQUIPMENT_VAR_LOG_REQUEST";
const EQUIPMENT_CONFIG_RETRIEVE = "EQUIPMENT_CONFIG_RETRIEVE";
const EQUIPMENT_BOUNCE_INTERFACE = "EQUIPMENT_BOUNCE_INTERFACE";
const EQUIPMENT_CLEAR_MACTABLE = "EQUIPMENT_CLEAR_MACTABLE";
const EQUIPMENT_DEVICE_CHECK = "EQUIPMENT_DEVICE_CHECK";
const EQUIPMENT_NETBOX_CHECK = "EQUIPMENT_NETBOX_CHECK";
const EQUIPMENT_SYNC_PHYSICAL = "EQUIPMENT_SYNC_PHYSICAL";
const EQUIPMENT_NETBOX_UPDATE = "EQUIPMENT_NETBOX_UPDATE";
const EQUIPMENT_ROLLBACK_COMPARE = "EQUIPMENT_ROLLBACK_COMPARE";
const EQUIPMENT_ALARM_CHECK = "EQUIPMENT_ALARM_CHECK";
const EQUIPMENT_FACTS_CHECK = "EQUIPMENT_FACTS_CHECK";
const EQUIPMENT_HARDWARE_RETRIEVE = "EQUIPMENT_HARDWARE_RETRIEVE";
const EQUIPMENT_INTERFACE_RETRIEVE = "EQUIPMENT_INTERFACE_RETRIEVE";
const EQUIPMENT_INTERFACES_RETRIEVE = "EQUIPMENT_INTERFACES_RETRIEVE"
const EQUIPMENT_INTERFACE_OPTICS = "EQUIPMENT_INTERFACE_OPTICS";
const EQUIPMENT_LICENSES_RETRIEVE = "EQUIPMENT_LICENSES_RETRIEVE";
const EQUIPMENT_INTERFACE_LOGS = "EQUIPMENT_INTERFACE_LOGS";
const EQUIPMENT_INSTANCE_MACTABLE = "EQUIPMENT_INSTANCE_MACTABLE";
const EQUIPMENT_UPTIME_RETRIEVE = "EQUIPMENT_UPTIME_RETRIEVE";
const VPLS_CONNECTIONS_RETRIEVE = "VPLS_CONNECTIONS_RETRIEVE";
const ROUTER_IPSEC_RESET = "ROUTER_IPSEC_RESET";
const CIENA_INVENTORY_REQUEST = "CIENA_INVENTORY_REQUEST";
const JUNIPER_INVENTORY_REQUEST = "JUNIPER_INVENTORY_REQUEST";
const JUNIPER_INVENTORY_REQUEST_PHYSICAL = "JUNIPER_INVENTORY_REQUEST_PHYSICAL";
const EQUIPMENT_INVENTORY_REPORT_REQUEST = "EQUIPMENT_INVENTORY_REPORT_REQUEST";
const EQUIPMENT_CARDS_REQUEST = "EQUIPMENT_CARDS_REQUEST";
const EQUIPMENT_PORTS_REQUEST = "EQUIPMENT_PORTS_REQUEST";
const ZABBIX_NOTIFICATIONS_REQUEST = "ZABBIX_NOTIFICATIONS_REQUEST";
const ZABBIX_NOTIFICATIONS_SUCCESS = "ZABBIX_NOTIFICATIONS_SUCCESS";
const ZABBIX_NOTIFICATIONS_ERROR = "ZABBIX_NOTIFICATIONS_ERROR";
const ZABBIX_NOTIFICATIONS_SEARCH = "ZABBIX_NOTIFICATIONS_SEARCH";
const ZABBIX_NOTIFICATION_MUTE = "ZABBIX_NOTIFICATION_MUTE";
const ZABBIX_NOTIFICATION_UNMUTE = "ZABBIX_NOTIFICATION_UNMUTE";
const VPLS_MACTABLE_REQUEST = "VPLS_MACTABLE_REQUEST";
const VPLS_MACTABLE_SUCCESS = "VPLS_MACTABLE_SUCCESS";
const VPLS_MACTABLE_ERROR = "VPLS_MACTABLE_ERROR"

//Equipment Profile Generation
const SITE_MANAGER_PROFILE_REQUEST = "SITE_MANAGER_PROFILE_REQUEST";
const MREMOTE_PROFILE_REQUEST = "MREMOTE_PROFILE_REQUEST";
const POWERSUITE_PROFILE_REQUEST = "POWERSUITE_PROFILE_REQUEST";

//SPack Endpoints
const SPACK_STATS_REQUEST = "SPACK_STATS_REQUEST";
const SPACK_STATS_SUCCESS = "SPACK_STATS_SUCCESS";
const SPACK_STATS_ERROR = "SPACK_STATS_ERROR";

import Vue from "vue";

const state = { status: "", 
  equipment: null, 
  inventory: null, 
  cards: null, 
  alarmTypes:[
    {
      alarm: 'warning',
      colour: '#2caae1',
      textColour: 'twitter'
    },
    {
      alarm: 'minor',
      colour: '#d0d314',
      textColour: 'planning'
    },
    {
      alarm: 'major',
      colour: '#f5a623',
      textColour: 'warning'
    },
    {
      alarm: 'critical',
      colour: '#ff4747',
      textColour: 'danger'
    }
  ],
  zabbixTriggers: null
};

const getters = {
  getEquipment: (state) => state.equipment === null ? [] : state.equipment,
  searchEquipment: (state) => (searchParam) => {
    var searchTerm = new RegExp(searchParam, "i");
    return state.equipment === null ? [] : state.equipment.filter(
      (equipment) =>
        searchTerm.test(equipment.equipmentname) ||
        searchTerm.test(equipment.ipaddress)
    );
  },
  getAlarmType: (state) => (alarmType) => {
    return state.alarmTypes.find(
      (thisAlarm) => thisAlarm.alarm === alarmType
    );
  },
  isEquipmentLoaded:  state => !!state.equipment,
  isInventoryLoaded:  state => !!state.inventory,
  isCardsLoaded: state => !!state.cards,
  isTriggersLoaded: state=> !!state.zabbixTriggers,
  getEquipmentCards: (state) => (shelfId) => {
    const shelf = (state.equipment === null || state.cards == null) ? [] : state.cards.find(
      (thisCard) => thisCard.equipid === shelfId
    );
    return shelf;
  },
  getSiteEquipment:(state) => (siteid) => {
    return state.equipment === null ? [] : state.equipment.filter(thisEquipment => thisEquipment.siteid == siteid)
  },
  getTriggers:(state) => state.zabbixTriggers ? state.zabbixTriggers : [],
  getInventory: (state) => state.inventory === null ? [] : state.inventory,
  getShelf: (state) => (shelfId) => {
    const shelf = state.equipment === null ? {} : state.equipment.find(
      (shelf) => shelf.equipmentid === shelfId
    );
    return shelf;
  },
  getShelfByName: (state) => (shelfName) => {
    const shelf = state.equipment === null ? {} : state.equipment.find(
      (shelf) => shelf.equipmentname === shelfName
    );
    return shelf;
  },
  getFeeding: (state) => (shelfId) => {
    return state.equipment === null ? [] : state.equipment.filter((eq) => eq.spack === shelfId);
  },
  getSparePartsInventory: (state) => state.inventory === null ? [] : state.inventory,
};

const actions = {
  [EQUIPMENT_REQUEST]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(EQUIPMENT_REQUEST);
      commit("addLoading", {
        handle: "equipment",
        name: "Load Equipment Data",
      });


      let loginDetails = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "shelves", loginDetails).then(response =>{
          if(response.ok){ //Successful response and payload
              response.json().then(resp => {
                  commit("removeLoading", "equipment");
                  if (resp.result === 'Success') {
                    commit(EQUIPMENT_SUCCESS, resp);
                    resolve(resp)
                  } else {
                      commit(EQUIPMENT_ERROR)
                      reject(resp)
                  }
              })
          } else { //Error
              commit(EQUIPMENT_ERROR);
              commit("removeLoading", "equipment");
              if (response.status == '403') {
                  dispatch(AUTHTOKEN_LOGOUT);
              } 
              response.json().then(err => {
                  reject(err)
              })            
          }
      })
    });
  },
  [EQUIPMENT_CARDS_REQUEST]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(EQUIPMENT_CARDS_REQUEST);
      commit("addLoading", {
        handle: "equipmentcards",
        name: "Load Equipment Cards",
      });


      let loginDetails = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "equipmentcards", loginDetails).then(response =>{
          if(response.ok){ //Successful response and payload
              response.json().then(resp => {
                  commit("removeLoading", "equipmentcards");
                  if (resp.result === 'Success') {
                    commit(EQUIPMENT_SUCCESS, resp);
                    resolve(resp)
                  } else {
                      commit(EQUIPMENT_ERROR)
                      reject(resp)
                  }
              })
          } else { //Error
              commit(EQUIPMENT_ERROR);
              commit("removeLoading", "equipmentcards");
              if (response.status == '403') {
                  dispatch(AUTHTOKEN_LOGOUT);
              } 
              response.json().then(err => {
                  reject(err)
              })            
          }
      })
    });
  },
  [EQUIPMENT_PORTS_REQUEST]: ({ commit, dispatch }, equipmentid) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "equipmentports",
        name: "Load Equipment Ports",
      });

      
      let loginDetails = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "equipment/" + equipmentid + "/ports", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
            response.json().then(resp => {
                commit("removeLoading", "equipmentports");
                if (resp.result === 'Success') {
                  resolve(resp)
                } else {
                    reject(resp)
                }
            })
        } else { //Error
            commit("removeLoading", "equipmentports");
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [ZABBIX_NOTIFICATIONS_REQUEST]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(ZABBIX_NOTIFICATIONS_REQUEST);
      commit("addLoading", {
        handle: "zabbixNotifications",
        name: "Loading Muted Zabbix Notifications",
      });


      let loginDetails = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "zabbix/trigger/muted", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
            response.json().then(resp => {
                commit("removeLoading", "zabbixNotifications");
                if (resp.result === 'Success') {
                  commit(ZABBIX_NOTIFICATIONS_SUCCESS, resp);
                  resolve(resp)
                } else {
                  commit(ZABBIX_NOTIFICATIONS_ERROR);
                    reject(resp)
                }
            })
        } else { //Error
            commit("removeLoading", "zabbixNotifications");
            commit(ZABBIX_NOTIFICATIONS_ERROR);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [ZABBIX_NOTIFICATIONS_SEARCH]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      //commit(ZABBIX_NOTIFICATIONS_REQUEST);
      commit("addLoading", {
        handle: "zabbixSearchNotifications",
        name: "Searching Zabbix Notifications",

      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "zabbix/trigger/search", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
            response.json().then(resp => {
                commit("removeLoading", "zabbixSearchNotifications");
                if (resp.result === 'Success') {
                //  commit(ZABBIX_NOTIFICATIONS_SUCCESS, resp);
                  resolve(resp)
                } else {
                  commit(ZABBIX_NOTIFICATIONS_ERROR);
                    reject(resp)
                }
            })
        } else { //Error
            commit("removeLoading", "zabbixSearchNotifications");
            commit(ZABBIX_NOTIFICATIONS_ERROR);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [ZABBIX_NOTIFICATION_MUTE]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "muteNotification" + payload.triggerid,
        name: "Muting Zabbix Notification",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "zabbix/trigger/mute", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
            response.json().then(resp => {
                commit("removeLoading", "muteNotification" + payload.triggerid);
                if (resp.result === 'Success') {
                //  commit(ZABBIX_NOTIFICATIONS_SUCCESS, resp);
                  resolve(resp)
                } else {
                  commit(ZABBIX_NOTIFICATIONS_ERROR);
                    reject(resp)
                }
            })
        } else { //Error
            commit("removeLoading", "muteNotification" + payload.triggerid);
            commit(ZABBIX_NOTIFICATIONS_ERROR);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
    [ZABBIX_NOTIFICATION_UNMUTE]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "unmuteNotification" + payload.triggerid,
        name: "Muting Zabbix Notification",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "zabbix/trigger/unmute", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
            response.json().then(resp => {
                commit("removeLoading", "unmuteNotification" + payload.triggerid);
                if (resp.result === 'Success') {
                //  commit(ZABBIX_NOTIFICATIONS_SUCCESS, resp);
                  resolve(resp)
                } else {
                  commit(ZABBIX_NOTIFICATIONS_ERROR);
                    reject(resp)
                }
            })
        } else { //Error
            commit("removeLoading", "unmuteNotification" + payload.triggerid);
            commit(ZABBIX_NOTIFICATIONS_ERROR);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [SPARES_INVENTORY_REQUEST]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "sparepartsinventory",
        name: "Load Spare Parts Inventory",
      });


      let loginDetails = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "inventory", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
            response.json().then(resp => {
                commit("removeLoading", "sparepartsinventory");
                if (resp.result === 'Success') {
                  commit(SPARES_INVENTORY_SUCCESS, resp);
                  resolve(resp)
                } else {
                  commit(EQUIPMENT_ERROR);
                    reject(resp)
                }
            })
        } else { //Error
            commit("removeLoading", "sparepartsinventory");
            commit(EQUIPMENT_ERROR);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [SPARES_INVENTORY_UPDATE]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(SPARES_INVENTORY_REQUEST);
      commit("addLoading", {
        handle: "inventoryupdate",
        name: "update Spare Parts Inventory",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "inventory/ventia", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
            response.json().then(resp => {
                commit("removeLoading", "inventoryupdate");
                if (resp.result === 'Success') {
                  commit(SPARES_INVENTORY_UPDATE_SUCCESS);
                  resolve(resp)
                } else {
                  commit(EQUIPMENT_ERROR);
                    reject(resp)
                }
            })
        } else { //Error
            commit("removeLoading", "inventoryupdate");
            commit(EQUIPMENT_ERROR);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [SPARES_INVENTORY_CREATE_ENTRY]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(SPARES_INVENTORY_REQUEST);
      commit("addLoading", {
        handle: "addInventoryEntry",
        name: "Adding Inventory Item",
      });

      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "inventory", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
            response.json().then(resp => {
                commit("removeLoading", "addInventoryEntry");
                if (resp.result === 'Success') {
                  commit(SPARES_INVENTORY_UPDATE_SUCCESS);
                  resolve(resp)
                } else {
                  commit(EQUIPMENT_ERROR);
                    reject(resp)
                }
            })
        } else { //Error
            commit("removeLoading", "addInventoryEntry");
            commit(EQUIPMENT_ERROR);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [SPARES_INVENTORY_UPDATE_ENTRY]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(SPARES_INVENTORY_REQUEST);
      commit("addLoading", {
        handle: "updateInventoryEntry",
        name: "Update Inventory Item",
      });


      let loginDetails = {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + 'inventory/' + payload.uuid, loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
            response.json().then(resp => {
                commit("removeLoading", "updateInventoryEntry");
                if (resp.result === 'Success') {
                  commit(SPARES_INVENTORY_UPDATE_SUCCESS);
                  resolve(resp)
                } else {
                  commit(EQUIPMENT_ERROR);
                    reject(resp)
                }
            })
        } else { //Error
            commit("removeLoading", "updateInventoryEntry");
            commit(EQUIPMENT_ERROR);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [SPARES_INVENTORY_DELETE_ENTRY]: ({commit, dispatch}, deletedItem) => {
    return new Promise((resolve, reject) => {
      commit(SPARES_INVENTORY_DELETE_ENTRY);
      commit('addLoading', {handle:'inventorydelete'+deletedItem , name:'Delete Equipment'})


      let loginDetails = {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + 'inventory/' + deletedItem, loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
            response.json().then(resp => {
                commit('removeLoading', 'inventorydelete'+deletedItem)
                if (resp.result === 'Success') {
                  commit(EQUIPMENT_DELETE_SUCCESS, resp);
                  resolve(resp)
                } else {
                  commit(EQUIPMENT_ERROR);
                    reject(resp)
                }
            })
        } else { //Error
            commit('removeLoading', 'inventorydelete'+deletedItem)
            commit(EQUIPMENT_ERROR);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    })
  },
  [SITE_EQUIPMENT_REQUEST]: ({ commit, dispatch }, siteid) => {
    return new Promise((resolve, reject) => {
      commit(SITE_EQUIPMENT_REQUEST);
      commit("addLoading", {
        handle: "siteequipment",
        name: "Load Site Equipment Data",
      });


      let loginDetails = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "site/"+ siteid + "/equipment", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", "siteequipment");
              if (resp.result === 'Success') {
                commit(SITE_EQUIPMENT_SUCCESS, resp);
                resolve(resp)
              } else {
                commit(SITE_EQUIPMENT_ERROR);
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", "siteequipment");
            commit(SITE_EQUIPMENT_ERROR);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENTDETAIL_REQUEST]: ({ commit, dispatch }, equipmentid) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "equipmentdetail",
        name: "Load Equipment Data",
      });


      let loginDetails = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "equipment/" + equipmentid, loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", "equipmentdetail");
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", "equipmentdetail");
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENTALARMS_REQUEST]: ({ commit, dispatch }, equipmentid) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "equipmentalarms",
        name: "Load Equipment Alarms",
      });


      let loginDetails = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "equipment/" + equipmentid + "/alarms", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", "equipmentalarms");
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", "equipmentalarms");
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENTRESYNC_REQUEST]: ({ commit, dispatch }, equipmentid) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "equipmentresync",
        name: "Resync Equipment Data",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "equipment/" + equipmentid + "/update", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", "equipmentresync");
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", "equipmentresync");
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },

  //AWX Jobs
  [ROUTER_IPSEC_RESET]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "resetIPSEC",
        name: "Resetting Microtik IPSec SA's",
      });

      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/run/resetipsec", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", "resetIPSEC");
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", "resetIPSEC");
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_CONFIG_RETRIEVE]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "equipmentconfig" + payload.equipmentarray.tostring,
        name: "Request RSI",
      });

      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/get/config", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", "equipmentconfig" + payload.equipmentarray.tostring);
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", "equipmentconfig" + payload.equipmentarray.tostring);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENTRSI_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "equipmentrsi" + payload.equipmentarray.tostring,
        name: "Request RSI",
      });

      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/get/rsi", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", "equipmentrsi" + payload.equipmentarray.tostring);
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", "equipmentrsi" + payload.equipmentarray.tostring);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },


  [CIENA_INVENTORY_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "log" + payload.equipmentarray.tostring,
        name: "Ciena Inventory",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/run/cienainventory", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", "log" + payload.equipmentarray.tostring);
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", "log" + payload.equipmentarray.tostring);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },

  [JUNIPER_INVENTORY_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "log" + payload.equipmentarray.tostring,
        name: "Juniper Inventory",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/run/juniperinventory/full", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", "log" + payload.equipmentarray.tostring);
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", "log" + payload.equipmentarray.tostring);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },

  [JUNIPER_INVENTORY_REQUEST_PHYSICAL]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "log" + payload.equipmentarray.tostring,
        name: "Juniper Inventory",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/run/juniperinventory/physical", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", "log" + payload.equipmentarray.tostring);
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", "log" + payload.equipmentarray.tostring);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },

  [EQUIPMENT_INVENTORY_REPORT_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "shelfInventory",
        name: "Generating Shelf Inventory",
      });

      let loginDetails = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
       //   body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "equipment/"+payload.equipmentid+"/inventory/" + payload.format, loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          commit("removeLoading", "shelfInventory");
          if(payload.format == 'CSV'){ 
            response.blob().then(resp => {
              resolve(resp)
            })
          } else if (payload.format == 'JSON'){
            response.json().then(resp => {
                if (resp.result === 'Success') {
                  resolve(resp)
                } else {
                  reject(resp)
                }
            })
          } 
        } else { //Error
            commit("removeLoading", "shelfInventory");
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_LOG_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "log" + payload.equipmentarray.tostring,
        name: "Request log",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/get/log", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", "log" + payload.equipmentarray.tostring);
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", "log" + payload.equipmentarray.tostring);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_VAR_LOG_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "varlog" + payload.equipmentarray.tostring,
        name: "Request var/log",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/get/varlog", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", "varlog" + payload.equipmentarray.tostring);
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", "varlog" + payload.equipmentarray.tostring);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })  
    });
  },
  [EQUIPMENT_UPTIME_RETRIEVE]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "uptime" + payload.equipmentarray.tostring,
        name: "Request Uptime",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/show/uptime", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", "uptime" + payload.equipmentarray.tostring);
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", "uptime" + payload.equipmentarray.tostring);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })  
    });
  },
  [EQUIPMENT_BOUNCE_INTERFACE]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "bounceinterface" + payload.portid,
        name: "Bouncing Interface " + payload.portid,
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/run/bounceport", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", "bounceinterface" + payload.portid,);
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", "bounceinterface" + payload.portid,);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })  
    });
  },
  [EQUIPMENT_INTERFACE_LOGS]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "interfacelog",
        name: "Requesting Interface Log",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/show/logsfiltered", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", 'interfacelog');
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", 'interfacelog');
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_INSTANCE_MACTABLE]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "instancemactable",
        name: "Requesting Instance MAC Table",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/show/mactable", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", 'instancemactable');
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", 'instancemactable');
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_CLEAR_MACTABLE]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "clearmactable",
        name: "Clearing Interface MAC Table...",
      });

      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/run/clearmactable", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", 'clearmactable');
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", 'clearmactable');
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_DEVICE_CHECK]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "devicecheck",
        name: "Checking Shelf Config",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/run/config/devicecheck", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", 'devicecheck');
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", 'devicecheck');
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_SYNC_PHYSICAL]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "syncinventory",
        name: "Syncing Inventory with Netbox",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/run/update/netbox", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", 'syncinventory');
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", 'syncinventory');
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_NETBOX_CHECK]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "netboxcheck",
        name: "Checking Netbox Config",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/run/config/netboxcheck", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", 'netboxcheck');
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", 'netboxcheck');
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_NETBOX_UPDATE]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "netboxupdate",
        name: "Checking Netbox Config",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/run/update/netbox", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", 'netboxupdate');
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", 'netboxupdate');
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_ROLLBACK_COMPARE]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "rollbackcompare",
        name: "Comparing Rollback",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/run/rollbackcompare", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", 'rollbackcompare');
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", 'rollbackcompare');
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_ALARM_CHECK]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "getalarms",
        name: "Retrieving Shelf Alarms",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/show/alarms", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", 'getalarms');
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", 'getalarms');
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_FACTS_CHECK]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "getfacts",
        name: "Retrieving Shelf Facts",
      });

      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/show/facts", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", 'getfacts');
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", 'getfacts');
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_HARDWARE_RETRIEVE]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "gethardware",
        name: "Retrieving Shelf Hardware",
      });

      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/show/hardware", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", 'gethardware');
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", 'gethardware');
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_INTERFACE_RETRIEVE]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "getinterface",
        name: "Retrieving Interface",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/show/interface", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", 'getinterface');
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", 'getinterface');
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_INTERFACES_RETRIEVE]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "getinterfaces",
        name: "Retrieving Interfaces",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/show/interfaces", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", 'getinterfaces');
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", 'getinterfaces');
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_INTERFACE_OPTICS]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "getinterfaceOptics",
        name: "Retrieving Interface Optics",
      });

      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/show/interfaceoptics", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", 'getinterfaceOptics');
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", 'getinterfaceOptics');
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_LICENSES_RETRIEVE]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "getalarms",
        name: "Retrieving Shelf Licenses",
      });


      let loginDetails = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
          body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/show/license", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", 'getalarms');
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", 'getalarms');
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [SPACK_STATS_REQUEST]: ({ commit }, equipmentid) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "spackdetail",
        name: "Load SPack Data",
      });


      let loginDetails = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "tools/spackstats/" + equipmentid, loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", 'spackdetail');
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", 'spackdetail');
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [PORT_LIGHT_REQUEST]: ({ commit, dispatch }, portID ) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "portlight" + portID,
        name: "Load Port " + portID + " Light Levels",
      });

      let loginDetails = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "port/" + portID + "/lightlevels", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", "portlight" + portID);
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", "portlight" + portID);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })

    });
  },
  [PORT_TRAFFIC_REQUEST]: ({ commit, dispatch },  portID ) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "porttraffic" + portID,
        name: "Load Port " + portID + " Traffic",
      });


      let loginDetails = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "port/" + portID + "/trafficvalues", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit("removeLoading", "porttraffic" + portID);
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit("removeLoading", "porttraffic" + portID);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [PORT_LIGHTHISTORY_REQUEST]: ({commit, dispatch}, { portID, charttimespan}) => {
    return new Promise((resolve, reject) => {
        commit('addLoading', {handle: 'portlighthistory'+portID, name: 'Load Port '+portID+ ' Light History'})


        let loginDetails = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
        };
                          
        fetch(Vue.prototype.$apiServer + 'port/'+ portID + '/lighthistory/' + charttimespan, loginDetails).then(response =>{
          if(response.ok){ //Successful response and payload
            response.json().then(resp => {
                commit("removeLoading", "portlighthistory" + portID);
                if (resp.result === 'Success') {
                  resolve(resp)
                } else {
                    reject(resp)
                }
            })
          } else { //Error
              commit("removeLoading", "portlighthistory" + portID);
              if (response.status == '403') {
                  dispatch(AUTHTOKEN_LOGOUT);
              } 
              response.json().then(err => {
                  reject(err)
              })            
          }
        })
    })
  },
  [PORT_TRAFFICHISTORY_REQUEST]: ({commit, dispatch}, { portID, charttimespan}) => {
    return new Promise((resolve, reject) => {
        commit('addLoading', {handle: 'porttraffichistory'+portID, name: 'Load Port '+portID+ ' Traffic History'})

        let loginDetails = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //    body: JSON.stringify(payload)
        };
                          
        fetch(Vue.prototype.$apiServer + 'port/'+ portID + '/traffichistory/' + charttimespan, loginDetails).then(response =>{
          if(response.ok){ //Successful response and payload
            response.json().then(resp => {
                commit("removeLoading", "porttraffichistory" + portID);
                if (resp.result === 'Success') {
                  resolve(resp)
                } else {
                    reject(resp)
                }
            })
          } else { //Error
              commit("removeLoading", "porttraffichistory" + portID);
              if (response.status == '403') {
                  dispatch(AUTHTOKEN_LOGOUT);
              } 
              response.json().then(err => {
                  reject(err)
              })            
          }
        })
    })
  },
  [PORT_LINKSTATUS_REQUEST]: ({commit, dispatch},  portID ) => {
      return new Promise((resolve, reject) => {
          commit('addLoading', {handle: 'portlink'+portID, name: 'Load Port '+portID+ ' Status'})


          let loginDetails = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
        //    body: JSON.stringify(payload)
          };
                            
          fetch(Vue.prototype.$apiServer + 'port/'+portID + '/operationalstatus', loginDetails).then(response =>{
            if(response.ok){ //Successful response and payload
              response.json().then(resp => {
                  commit("removeLoading", "portlink" + portID);
                  if (resp.result === 'Success') {
                    resolve(resp)
                  } else {
                      reject(resp)
                  }
              })
            } else { //Error
                commit("removeLoading", "portlink" + portID);
                if (response.status == '403') {
                    dispatch(AUTHTOKEN_LOGOUT);
                } 
                response.json().then(err => {
                    reject(err)
                })            
            }
          })
      })
  },
  [PORT_DETAILS_REQUEST]: ({commit, dispatch}, payload ) => {
    return new Promise((resolve, reject) => {
        commit('addLoading', {handle: 'portdetails'+payload.portid, name: 'Load Port '+payload.portName+ ' Details'})


        let loginDetails = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
        //    body: JSON.stringify(payload)
          };
                            
          fetch(Vue.prototype.$apiServer + 'port/'+payload.portid, loginDetails).then(response =>{
            if(response.ok){ //Successful response and payload
              response.json().then(resp => {
                  commit('removeLoading', 'portdetails'+payload.portid)
                  if (resp.result === 'Success') {
                    resolve(resp)
                  } else {
                      reject(resp)
                  }
              })
            } else { //Error
                commit('removeLoading', 'portdetails'+payload.portid)
                if (response.status == '403') {
                    dispatch(AUTHTOKEN_LOGOUT);
                } 
                response.json().then(err => {
                    reject(err)
                })            
            }
          })
      })
  },
  [VPLS_CONNECTIONS_RETRIEVE]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "getvplsconnections",
        name: "Retrieving VPLS Instance Connections",
      });


      let loginDetails = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
        body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "awx/show/vplsconnections", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.json().then(resp => {
              commit('removeLoading', 'getvplsconnections')
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                  reject(resp)
              }
          })
        } else { //Error
            commit('removeLoading', 'getvplsconnections')
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_CREATE]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(EQUIPMENT_CREATE);
            commit('addLoading', {handle:'equipcreate',name:'Creating New Equipment'})


            let loginDetails = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
              body: JSON.stringify(payload)
            };
                              
            fetch(Vue.prototype.$apiServer + 'equipment', loginDetails).then(response =>{
              if(response.ok){ //Successful response and payload
                response.json().then(resp => {
                    commit('removeLoading', 'equipcreate')
                    if (resp.result === 'Success') {
                      resolve(resp)
                    } else {
                        reject(resp)
                    }
                })
              } else { //Error
                  commit('removeLoading', 'equipcreate')
                  if (response.status == '403') {
                      dispatch(AUTHTOKEN_LOGOUT);
                  } 
                  response.json().then(err => {
                      reject(err)
                  })            
              }
            })
        })
    },
    [EQUIPMENT_UPDATE]: ({ commit, dispatch }, payload) => {
      return new Promise((resolve, reject) => {
          commit(EQUIPMENT_UPDATE);
          commit('addLoading', {handle:'equipmentupdate',name:'Updating Equipment'})


          let loginDetails = {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
              body: JSON.stringify(payload)
            };
                              
            fetch(Vue.prototype.$apiServer + 'equipment/' + payload.equipmentid, loginDetails).then(response =>{
              if(response.ok){ //Successful response and payload
                response.json().then(resp => {
                    commit('removeLoading', 'equipmentupdate')
                    if (resp.result === 'Success') {
                      commit(EQUIPMENT_UPDATE_SUCCESS, resp);
                      dispatch(EQUIPMENT_REQUEST);
                      resolve(resp)
                    } else {
                      commit(EQUIPMENT_UPDATE_ERROR);
                      reject(resp)
                    }
                })
              } else { //Error
                  commit('removeLoading', 'equipmentupdate')
                  commit(EQUIPMENT_UPDATE_ERROR);
                  if (response.status == '403') {
                      dispatch(AUTHTOKEN_LOGOUT);
                  } 
                  response.json().then(err => {
                      reject(err)
                  })            
              }
            })
      })
    },
    [EQUIPMENT_DELETE]: ({commit, dispatch}, payload) => {
      return new Promise((resolve, reject) => {
          commit(EQUIPMENT_DELETE);
          commit('addLoading', {handle:'equipmentdelete'+payload ,name:'Delete Equipment'})


          let loginDetails = {
              method: 'DELETE',
              headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
              body: JSON.stringify(payload)
            };
                              
            fetch(Vue.prototype.$apiServer + 'equipment/' + payload, loginDetails).then(response =>{
              if(response.ok){ //Successful response and payload
                response.json().then(resp => {
                    commit('removeLoading', 'equipmentdelete'+payload)
                    if (resp.result === 'Success') {
                      commit(EQUIPMENT_DELETE_SUCCESS, resp);
                      dispatch(EQUIPMENT_REQUEST);
                      resolve(resp)
                    } else {
                      commit(EQUIPMENT_DELETE_ERROR);
                      reject(resp)
                    }
                })
              } else { //Error
                  commit('removeLoading', 'equipmentdelete'+payload)
                  commit(EQUIPMENT_DELETE_ERROR);
                  if (response.status == '403') {
                      dispatch(AUTHTOKEN_LOGOUT);
                  } 
                  response.json().then(err => {
                      reject(err)
                  })            
              }
            })
      })
  },
  [SITE_MANAGER_PROFILE_REQUEST]: ({ commit, dispatch } ) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "getSiteManager",
        name: "Generating Site Manager Profile",
      });


      let loginDetails = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //  body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "tools/generate/sitemanagerprofile", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.blob().then(resp => {
            commit("removeLoading", "getSiteManager");
            resolve(resp)
          })
        } else { //Error
            commit("removeLoading", "getSiteManager");
            commit(EQUIPMENT_DELETE_ERROR);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    })
  },

  


  [MREMOTE_PROFILE_REQUEST]: ({ commit, dispatch } ) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "getMRemote",
        name: "Generating mRemote Profile",
      });


      let loginDetails = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //  body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "tools/generate/mremotexml", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.blob().then(resp => {
            commit("removeLoading", "getMRemote");
            resolve(resp)
          })
        } else { //Error
            commit("removeLoading", "getMRemote");
            commit(EQUIPMENT_DELETE_ERROR);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [POWERSUITE_PROFILE_REQUEST]: ({ commit, dispatch } ) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "getPowersuite",
        name: "Generating PowerSuite Profile",
      });


      let loginDetails = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //  body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "tools/generate/powersuiteprofile", loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          response.blob().then(resp => {
            commit("removeLoading", "getPowersuite");
            resolve(resp)
          })
        } else { //Error
            commit("removeLoading", "getPowersuite");
            commit(EQUIPMENT_DELETE_ERROR);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    });
  },
  [EQUIPMENT_SITEINVENTORY_REQUEST]: ({ commit, dispatch }, payload ) => {
    return new Promise((resolve, reject) => {
      commit("addLoading", {
        handle: "getSiteInventory",
        name: "Generating Site Inventory File",
      });

      let loginDetails = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
      //  body: JSON.stringify(payload)
      };
                        
      fetch(Vue.prototype.$apiServer + "site/" + payload.siteid + '/inventory/' + payload.format, loginDetails).then(response =>{
        if(response.ok){ //Successful response and payload
          commit("removeLoading", "getSiteInventory");
          commit(EQUIPMENT_SITEINVENTORY_SUCCESS);
          if(payload.format == 'CSV'){ 
          response.blob().then(resp => {
            resolve(resp)
          })
        } else if (payload.format == 'JSON'){
          response.json().then(resp => {
              if (resp.result === 'Success') {
                resolve(resp)
              } else {
                reject(resp)
              }
            })
          }          
        } else { //Error
            commit("removeLoading", "getSiteInventory");
            commit(EQUIPMENT_SITEINVENTORY_ERROR);
            if (response.status == '403') {
                dispatch(AUTHTOKEN_LOGOUT);
            } 
            response.json().then(err => {
                reject(err)
            })            
        }
      })
    })
  },
};

const mutations = {
  [EQUIPMENT_REQUEST]: (state) => {
    state.status = "loading";
  },
  [EQUIPMENT_SUCCESS]: (state, resp) => {
    state.status = "success";
    Vue.set(state, "equipment", resp.payload);
  },
  [EQUIPMENT_ERROR]: (state) => {
    state.status = "error";
  },
  [ZABBIX_NOTIFICATIONS_REQUEST]: (state) => {
    state.status = "loading";
  },
  [ZABBIX_NOTIFICATIONS_SUCCESS]: (state, resp) => {
    state.status = "success";
    Vue.set(state, "zabbixTriggers", resp.payload);
  },
  [ZABBIX_NOTIFICATIONS_ERROR]: (state) => {
    state.status = "error";
  },
  [SPARES_INVENTORY_REQUEST]: (state) => {
    state.status = "loading";
  },
  [SPARES_INVENTORY_SUCCESS]: (state, resp) => {
    state.status = "success";
    Vue.set(state, "inventory", resp.payload);
  },
  [SPARES_INVENTORY_UPDATE_SUCCESS]: (state) => {
    state.status = "success";
  },
  [SPARES_INVENTORY_DELETE_ENTRY]: (state) => {
    state.status = "loading";
  },
  [SITE_EQUIPMENT_REQUEST]: (state) => {
    state.status = "loading";
  },
  [SITE_EQUIPMENT_SUCCESS]: (state, resp) => {
    state.status = "success";
    Vue.set(state, "equipment", resp.payload);
  },




  [SITE_EQUIPMENT_ERROR]: (state) => {
    state.status = "error";
  },
  [AUTHTOKEN_LOGOUT]: (state) => {
    state.equipment = [];
  },
  [VPLS_MACTABLE_REQUEST]: () => {
      state.vplsmacstatus = "loading";
  },
  [VPLS_MACTABLE_SUCCESS]: () => {
      state.vplsmacstatus = "success";
  },
  [VPLS_MACTABLE_ERROR]: () => {
      state.vplsmacstatus = "error";
  },
  [EQUIPMENT_CREATE]: (state) => {
    state.status = "loading";
  },
  [EQUIPMENT_CREATE_SUCCESS]: (state) => {
    state.status = "success";
  },
  [EQUIPMENT_CREATE_ERROR]: (state) => {
    state.status = "error";
  },
  [EQUIPMENT_UPDATE]: (state) => {
    state.status = "loading";
  },
  [EQUIPMENT_UPDATE_SUCCESS]: (state) => {
    state.status = "success";
  },
  [EQUIPMENT_UPDATE_ERROR]: (state) => {
    state.status = "error";
  },
  [EQUIPMENT_DELETE]: (state) => {
    state.status = "loading";
  },
  [EQUIPMENT_DELETE_SUCCESS]: (state) => {
    state.status = "success";
  },
  [EQUIPMENT_DELETE_ERROR]: (state) => {
    state.status = "error";
  },
  [SPACK_STATS_REQUEST]: (state) => {
    state.status = "loading";
  },
  [SPACK_STATS_SUCCESS]: (state) => {
    state.status = "success";
  },
  [SPACK_STATS_ERROR]: (state) => {
    state.status = "error";
  },
  [EQUIPMENT_SITEINVENTORY_REQUEST]: (state) => {
    state.status = "loading";
  },
  [EQUIPMENT_SITEINVENTORY_SUCCESS]: (state) => {
    state.status = "success";
  },
  [EQUIPMENT_SITEINVENTORY_ERROR]: (state) => {
    state.status = "error";
  },
  
};

export default {
  state,
  getters,
  actions,
  mutations,
};
